export { Translate } from "./translate.component";
